var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetBackAr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06883 19.5314C7.44399 18.9065 7.44399 17.8935 8.06883 17.2686L13.3375 12L8.06883 6.73137C7.44399 6.10653 7.44399 5.09347 8.06883 4.46863C8.69366 3.84379 9.70673 3.84379 10.3316 4.46863L16.7316 10.8686C17.3564 11.4935 17.3564 12.5065 16.7316 13.1314L10.3316 19.5314C9.70673 20.1562 8.69366 20.1562 8.06883 19.5314Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetBackAr);
export default __webpack_public_path__ + "static/media/vet-back-ar.f50231c9b34d66cf2b3a04efa8260095.svg";
export { ForwardRef as ReactComponent };